<template>
    <div class="panel reports-panel">
        <div class="reports-head">
            <div>
                <div class="panel-title">Reports Center</div>
            </div>
        </div>

        <div class="reports-grid">
            <div class="report-group" v-for="group in filteredGroups" :key="group.name" v-if="group.reports.length">
                <div class="report-group-label">{{ group.name }}</div>

                <div class="report-row" v-for="(report, index) in group.reports" :key="index"
                    :class="{ 'opacity-50 notAllowed': report.downloading }" @click="downloadReport(report)">

                    <div class="file-badge" :class="report.fileType">
                        <loader v-if="report.downloading" size="small"></loader>
                        <span v-else>{{ report.fileType === 'pdf' ? 'PDF' : 'XLS' }}</span>
                    </div>

                    <div class="report-info">
                        <span class="report-name">{{ report.name }}</span>
                        <span class="report-sub" v-if="report.subName">{{ report.subName }}</span>
                        <span class="report-status downloading" v-if="report.downloading">Downloading…</span>
                        <span class="report-status error" v-if="report.downloadError">Error downloading</span>
                    </div>
                </div>
            </div>

            <div class="empty-state" v-if="!hasVisibleReports">
                <span>No reports available</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/tools/loaders/loader1'

export default {
    data() {
        return {
            search: '',
            reportsBase: [
                {
                    name: 'Agents', subName: 'by sale date', url: '/api/Booking/Sales',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'agents', params: { 's.onlyAgents': true },
                    allowedToAccess: ['admin', 'mainSupervisor', 'agentSupervisor']
                },
                {
                    name: 'Agents', subName: 'by departure date', url: '/api/Report/AgentEventSales',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'agents', params: { 's.onlyAgents': true },
                    allowedToAccess: ['admin', 'mainSupervisor', 'agentSupervisor']
                },
                {
                    name: 'Agent Sales', url: '/api/report/DownloadPDFAgentsSales',
                    fileType: 'pdf', downloading: false, downloadError: false, active: true, specialRequest: true,
                    category: 'agents',
                    allowedToAccess: ['admin', 'mainSupervisor', 'agentSupervisor']
                },
                {
                    name: 'Agent Sales', subName: 'by product', url: '/api/Report/AgentsPerExperienceAndPerResourceType',
                    fileType: 'pdf', downloading: false, downloadError: false, active: true, specialRequest: true,
                    category: 'agents',
                    allowedToAccess: ['admin', 'mainSupervisor', 'agentSupervisor']
                },
                {
                    name: 'Totals by Agent', url: '/api/Report/ReportSupplierAgentTotals',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'agents',
                    allowedToAccess: ['admin', 'mainSupervisor', 'agentSupervisor']
                },
                {
                    name: 'Sales', url: '/api/Booking/Sales',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'sales',
                    allowedToAccess: ['admin', 'mainSupervisor']
                },
                {
                    name: 'Extras Sales', url: '/api/Report/BookingExtraReport',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'sales',
                    allowedToAccess: ['admin', 'mainSupervisor', 'myTeamSupervisor']
                },
                {
                    name: 'Daily Summary', url: '/api/report/dailysummary',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'sales',
                    allowedToAccess: ['admin', 'mainSupervisor', 'myTeamSupervisor']
                },
                {
                    name: 'Team Resume', url: '/api/report/MyTeamResume',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'sales',
                    allowedToAccess: ['admin', 'mainSupervisor', 'myTeamSupervisor']
                },
                {
                    name: 'Widget Summary', url: '/api/report/WidgetSummary',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'channels',
                    allowedToAccess: ['admin', 'mainSupervisor', 'marketingSupervisor']
                },
                {
                    name: 'Widget Abandons', url: '/api/report/WidgetAbandons',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'channels',
                    allowedToAccess: ['admin', 'mainSupervisor', 'myTeamSupervisor']
                },
                {
                    name: 'Product Daily Sales', url: '/api/report/ReportBooking_DepartureGroupingSales',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'operations',
                    allowedToAccess: ['admin', 'mainSupervisor', 'myTeamSupervisor']
                },
                {
                    name: 'Event Resume', url: '/api/Report/EventResume',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'operations',
                    allowedToAccess: ['admin', 'mainSupervisor', 'myTeamSupervisor']
                },
                {
                    name: 'Event Departure Sales', url: '/api/report/EventDepartureSales',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'operations',
                    allowedToAccess: ['admin', 'mainSupervisor', 'myTeamSupervisor']
                },
                {
                    name: 'Product Totals', url: '/api/report/ReportBooking_DepartureGroupingSalesByProduct',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'operations',
                    allowedToAccess: ['admin', 'mainSupervisor', 'marketingSupervisor']
                },
                {
                    name: 'Resource Totals', url: '/api/report/ReportBooking_DepartureGroupingSalesByResource',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'operations',
                    allowedToAccess: ['admin', 'mainSupervisor']
                },
                {
                    name: 'Country Departures', url: '/api/Report/CountryDepartures',
                    fileType: 'xlsx', downloading: false, downloadError: false, active: true,
                    category: 'operations',
                    allowedToAccess: ['admin', 'mainSupervisor', 'marketingSupervisor']
                },
                {
                    uid: 'gyg', name: 'Get Your Guide', url: '/api/Report/DownloadPDFOTAs',
                    params: { 's.ChannelType': 202 },
                    fileType: 'pdf', downloading: false, downloadError: false,
                    category: 'channels',
                    active: function (vm) { return vm.getActiveIntegrations.getYourGuide },
                    allowedToAccess: ['admin', 'mainSupervisor', 'agentSupervisor', 'marketingSupervisor']
                },
                {
                    uid: 'viator', name: 'Viator', url: '/api/Report/DownloadPDFOTAs',
                    params: { 's.ChannelType': 203 },
                    fileType: 'pdf', downloading: false, downloadError: false,
                    category: 'channels',
                    active: function (vm) { return vm.getActiveIntegrations.viator },
                    allowedToAccess: ['admin', 'mainSupervisor', 'agentSupervisor', 'marketingSupervisor']
                },
                {
                    name: 'Bookings', uid: 'bookings', subName: 'Without Invoice',
                    url: '/api/Report/ReportBookingItemsWithoutInvoice',
                    fileType: 'xlsx', downloading: false, downloadError: false,
                    category: 'sales',
                    active: function (vm) { return vm.hasInvoiceSystem },
                    allowedToAccess: ['admin', 'mainSupervisor', 'marketingSupervisor']
                },
            ]
        }
    },
    props: [
        'subTitle',
        'dateFrom',
        'dateTo',
    ],
    computed: {
        ...mapGetters([
            'account',
            'getActiveIntegrations',
            'getAllIntegrations',
            'getHasInvoiceSystem',
        ]),
        filename() {
            return this.dateFrom == this.dateTo ? this.dateFrom : this.dateFrom + '_to_' + this.dateTo;
        },
        hasInvoiceSystem() {
            return this.getHasInvoiceSystem ? this.getHasInvoiceSystem : false;
        },
        reports() {
            return this.reportsBase
                .map(report => {
                    if (typeof report.active == 'function') {
                        report.active = report.active(this);
                    }
                    return report;
                })
                .filter(report => report.active && this.accessPermissionFilter(report.allowedToAccess));
        },
        filteredGroups() {
            const categories = [
                { key: 'sales', name: 'Sales & Bookings' },
                { key: 'agents', name: 'Agents & Partners' },
                { key: 'operations', name: 'Products & Operations' },
                { key: 'channels', name: 'Channels & Widgets' },
            ];

            const term = this.search.trim().toLowerCase();

            return categories.map(cat => {
                let reports = this.reports.filter(r => r.category === cat.key);

                if (term) {
                    reports = reports.filter(r =>
                        (r.name + ' ' + (r.subName || '')).toLowerCase().includes(term)
                    );
                }

                return { name: cat.name, reports };
            });
        },
        hasVisibleReports() {
            return this.filteredGroups.some(g => g.reports.length > 0);
        }
    },
    methods: {
        downloadReport(report) {
            if (report.downloading) {
                this.$toasted.info('Already downloading, please wait');
                return false;
            }

            let prefix = report.specialRequest ? 'request.' : 's.';

            let requestParams = {
                [`${prefix}supplierId`]: this.account.supplierId,
                [`${prefix}dateStart`]: this.dateFrom,
                [`${prefix}dateEnd`]: this.dateTo
            };

            Object.assign(requestParams, report.params);
            report.downloading = true;
            report.downloadError = false;

            axios.get(report.url, {
                params: requestParams,
                responseType: 'blob'
            }).then(response => {
                report.downloading = false;

                if (response.status == 200) {
                    window.URL = window.URL || window.webkitURL;
                    const headers = response.headers;
                    const blob = new Blob([response.data], { type: headers['content-type'] });
                    const link = document.createElement('a');
                    document.body.appendChild(link);
                    link.href = window.URL.createObjectURL(blob);
                    link.download = report.name + '_' + this.filename + '.' + report.fileType;
                    link.click();
                }
            }).catch(error => {
                report.downloading = false;
                report.downloadError = true;
            })
        },
        resetDownloads() {
            for (let report of this.reportsBase) {
                report.downloadError = false;
            }
        },
    },
    watch: {
        dateFrom: {
            handler() {
                this.resetDownloads();
            }
        },
        dateTo: {
            handler() {
                this.resetDownloads();
            }
        },
    },
    components: {
        Loader
    }
}
</script>

<style lang="scss" scoped>
.panel {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    padding: 1.25rem 1.4rem;
}

.panel-title {
    font-size: .95rem;
    font-weight: 700;
}

.reports-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1.1rem;
}

.search-box {
    position: relative;

    input {
        border: 1px solid var(--line);
        border-radius: 9px;
        padding: .5rem .8rem .5rem 2.1rem;
        font-size: .8rem;
        font-family: 'Inter';
        width: 230px;
        background: var(--paper);
        color: var(--ink);

        &:focus {
            outline: none;
            border-color: var(--ocean);
            background: #fff;
            box-shadow: 0 0 0 3px var(--ocean-soft);
        }
    }

    svg {
        position: absolute;
        left: .7rem;
        top: 50%;
        transform: translateY(-50%);
        width: 14px;
        height: 14px;
        stroke: var(--ink-faint);
    }
}

.reports-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
    max-height: 320px;
    overflow-y: auto;
    padding-right: .75rem;
    margin-right: -.75rem;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: var(--line);
        border-radius: 3px;

        &:hover {
            background: var(--ink-faint);
        }
    }

    @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
    }
}

.report-group-label {
    font-size: .66rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .05em;
    color: var(--ink-faint);
    padding-bottom: .45rem;
    border-bottom: 1px solid var(--line);
    margin-bottom: .5rem;
}

.report-row {
    display: flex;
    align-items: center;
    gap: .65rem;
    padding: .5rem .35rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background .15s ease;

    &:hover {
        background: var(--ocean-soft);

        .file-badge {
            background: var(--ocean);
            color: #fff;
        }
    }

    &.notAllowed {
        pointer-events: none;
    }
}

.file-badge {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: var(--paper);
    color: var(--ink-faint);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .62rem;
    font-weight: 700;
    font-family: 'IBM Plex Mono', monospace;
    flex-shrink: 0;
    transition: all .15s ease;

    &.pdf {
        color: #b5493f;
    }
}

.report-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.report-name {
    font-size: .8rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.report-sub {
    font-size: .68rem;
    color: var(--ink-faint);
}

.report-status {
    font-size: .68rem;

    &.downloading {
        color: var(--ocean);
    }

    &.error {
        color: var(--coral);
    }
}

.empty-state {
    grid-column: 1 / -1;
    text-align: center;
    padding: 2rem 0;
    color: var(--ink-faint);
    font-size: .85rem;
}
</style>


// WEBPACK FOOTER //
// reportsCenter.vue?137eeb43